import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs/operators';

@Injectable()
export class DashboardMesaControlService {

  constructor(public http: HttpClient) {}

  /**
   * Reporte extendido (factoraje + fondeo)
   * GET /api/v1/reports/used_date/:date/daily_operations_extended?general_report=SI
   */
  getDailyOperationsExtended(date: string, generalReport: string) {
    const url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/daily_operations_extended?general_report=${generalReport}`;
    return this.http.get(url).pipe(map((resp: any) => resp));
  }

  /**
   * Tasas Banxico del día
   * GET /api/v1/reports/banxico_rates/:date
   */
  getBanxicoRates(date: string) {
    const url = `${environment.URL_SERVICIOS}/reports/banxico_rates/${date}`;
    return this.http.get(url).pipe(map((resp: any) => resp));
  }

  /**
   * Operaciones agrupadas por fondeador
   * GET /api/v1/reports/used_date/:date/daily_operations_by_funder
   */
  getDailyOperationsByFunder(date: string) {
    const url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/daily_operations_by_funder`;
    return this.http.get(url).pipe(map((resp: any) => resp));
  }

  /**
   * Validación de cálculos y discrepancias
   * GET /api/v1/reports/used_date/:date/daily_operations_summary
   */
  getDailyOperationsSummary(date: string) {
    const url = `${environment.URL_SERVICIOS}/reports/used_date/${date}/daily_operations_summary`;
    return this.http.get(url).pipe(map((resp: any) => resp));
  }

  /**
   * Relación de cadenas y bancos para factoraje (no depende de fecha, se carga una sola vez)
   * GET /api/v1/reports/company_bank_rates
   * Agregado: 29/06/2026
   */
  getCompanyBankRates() {
    const url = `${environment.URL_SERVICIOS}/reports/company_bank_rates`;
    return this.http.get(url).pipe(map((resp: any) => resp));
  }
}
